// extracted by mini-css-extract-plugin
export default {"section":"OrderComments_section__j-5mf","textArea":"OrderComments_textArea__ZrhdA","title":"OrderComments_title__OWh-a"};